import React from 'react';
import { Box, Typography, Pagination } from '@mui/material';

const PaginationWithInfo = ({
    data,
    onPageChange,
    itemType = 'items',
    showFirstButton = true,
    showLastButton = true,
    color = 'warning',
    size = 'small'
}) => {
    if (!data?.data?.length) return null;

    const { page, limit, totalCount, pages } = data;
    const startItem = page * limit + 1;
    const endItem = Math.min((page + 1) * limit, totalCount);

    const handlePageChange = (event, newPage) => {
        onPageChange(newPage - 1);
    };

    return (
        <Box
            sx={{
                mt: 3,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 2,
            }}
        >
            <Typography variant="body2" color="text.secondary">
                Showing {startItem} to {endItem} of {totalCount} {itemType}
            </Typography>

            <Pagination
                count={pages || 0}
                page={page + 1}
                onChange={handlePageChange}
                color={color}
                size={size}
                showFirstButton={showFirstButton}
                showLastButton={showLastButton}
                sx={{
                    '& .MuiPaginationItem-root': {
                        color: `${color}.main`,
                        minWidth: 'fit-content',
                        width: 'fit-content',
                        height: '32px',
                        padding: '4px 8px',
                        '&.Mui-selected': {
                            backgroundColor: `${color}.main`,
                            color: 'white',
                            '&:hover': {
                                backgroundColor: `${color}.dark`,
                            },
                        },
                        '&:hover': {
                            backgroundColor: `${color}.light`,
                            color: 'white',
                        },
                    },
                }}
            />
        </Box>
    );
};

export default PaginationWithInfo;
